'use client'; // Error components must be Client Components

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {

    return (
        <div className="container pt-5">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 d-flex justify-content-center flex-column align-items-center">
                    <h2 className="h2 mt-3">Something went wrong!</h2>
                    <button
                        className="btn btn-primary mt-5"
                        onClick={
                            // Attempt to recover by trying to re-render the segment
                            () => reset()
                        }
                    >
                        Try again
                    </button>
                </div>
            </div>
        </div>
    );
}
